import Script from 'next/script';

import { useConsentManager } from './consent-manager';

/**
 * Load the RB2B script after airgap.js is initialized.
 */
export const Rb2bScript: React.FC = () => {
  const { airgap } = useConsentManager();

  return (
    <>
      {airgap && (
        <Script
          id="rb2b-init"
          strategy="lazyOnload"
          dangerouslySetInnerHTML={{
            __html: `
              !function(key) {
                if (window.reb2b) return;
                window.reb2b = { loaded: true };
                var s = document.createElement("script");
                s.async = true;
                s.src = "https://ddwl4m2hdecbv.cloudfront.net/b/" + key + "/" + key + ".js.gz";
                document.getElementsByTagName("script")[0].parentNode.insertBefore(s, document.getElementsByTagName("script")[0]);
              }("Z6PVLHQJGY6R");
            `,
          }}
        />
      )}
    </>
  );
};
